import { Injectable } from '@angular/core';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class CursosService {

  constructor(
    private invoke: InvocaService,
    private sessionService: SessionService
  ) {}

  async getCursosOfertados(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('public/getCursos', params);
  }
  async getCursosRecomendadosDisp(): Promise<any> {
    return await this.invoke.httpInvoke('public/getUltimosCursosOfertadosDisp');
  }
  async getCursosRecomendadosNoDisp(): Promise<any> {
    return await this.invoke.httpInvoke('public/getUltimosCursosOfertadosNoDisp');
  }
  async getCursosGratuitos(): Promise<any> {
    return await this.invoke.httpInvoke('public/getUltimosCursosPorTipo', { tipo_curso: 1});
  }
  async getCursosPrivados(): Promise<any> {
    return await this.invoke.httpInvoke('public/getUltimosCursosPorTipo', { tipo_curso: 4});
  }
  async getCursosDePago(): Promise<any> {
    return await this.invoke.httpInvoke('public/getUltimosCursosPorTipo', { tipo_curso: 2});
  }
  async getCursoPorIdVersion(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('public/getCursoPorIdVersion', params);
  }
  async validarCodigoAcceso(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('public/validarCodigoAcceso', params);
  }

  async obtenerCursosUsuario() {
    return this.invoke.httpInvoke('cursos/getCursosUsuario');
  }

  async getHrefCursoAula(id_curso_moodle: number) {
    return this.invoke.httpInvoke('cursos/getHrefCursoAula', {
      id_curso_moodle: id_curso_moodle
    });
  }

  async getCantidadCursosGratuitos(): Promise<any> {
    return await this.invoke.httpInvoke('public/getCantidadCursosGratuitos');
  }

}
